import type { SimulatorProfileDefinition } from "../contracts/appManifest.js";

export const clientCloudAdminProfile: SimulatorProfileDefinition = {
  id: "client-cloud-admin",
  title: "FirstDesk Cloud Admin Workstation",
  productLabel: "FirstDesk Cloud Admin Center",
  machineRole: "cloud",
  theme: "cloud",
  desktopAppIds: ["explorer", "settingsSystem", "cmd", "entraUsers", "entraGroups", "entraDevices", "m365Licenses"],
  pinnedAppIds: ["explorer", "settingsSystem", "cmd", "entraUsers", "intuneDevices"],
  defaultOpenAppIds: [],
  startMenuSections: [
    {
      title: "Cloud directory",
      appIds: ["entraUsers", "entraGroups", "entraDevices", "entraRoles"]
    },
    {
      title: "Cloud security",
      appIds: ["conditionalAccess", "authMethods", "enterpriseApps", "defenderPortal"]
    },
    {
      title: "Device management",
      appIds: ["intuneDevices", "compliancePolicies", "configurationProfiles", "m365Users", "m365Licenses"]
    },
    {
      title: "Workstation",
      appIds: ["explorer", "settingsSystem", "cmd", "notepad", "snippingTool", "clipboardHistory", "controlPrinters"]
    }
  ]
};
